export default __webpack_public_path__ + "static/assets/204b8f8b1980ce65ae8bf77b7f339c1f.svg";